'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const designSystem = require('@zapier/design-system');
const React = require('react');
const PageHeader_PageHeaderBase = require('./PageHeaderBase.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const headerWrapper = "_header-wrapper_10gs3_1";
const titleRow = "_title-row_10gs3_7";
const titleContent = "_title-content_10gs3_8";
const pageIcon = "_page-icon_10gs3_18";
const title = "_title_10gs3_7";
const pageTag = "_page-tag_10gs3_40";
const responsiveTag = "_responsive-tag_10gs3_45";
const actionsContainer = "_actions-container_10gs3_51";
const defaultActions = "_default-actions_10gs3_59";
const compactActions = "_compact-actions_10gs3_63";
const additionalContent = "_additional-content_10gs3_82";
const styles = {
	headerWrapper: headerWrapper,
	titleRow: titleRow,
	titleContent: titleContent,
	pageIcon: pageIcon,
	title: title,
	pageTag: pageTag,
	responsiveTag: responsiveTag,
	actionsContainer: actionsContainer,
	defaultActions: defaultActions,
	compactActions: compactActions,
	additionalContent: additionalContent
};

const PageHeader = ({ breadcrumbs, title, actions, compactActions, description, additionalContent, pageIcon, pageTag, pageIconColor = "inherit" }) => {
  return React__default.default.createElement(
    PageHeader_PageHeaderBase.PageHeaderBase,
    { topRowContent: breadcrumbs },
    React__default.default.createElement(
      "header",
      { className: styles.headerWrapper, "data-zds": true },
      React__default.default.createElement(
        "div",
        { className: styles.titleRow },
        React__default.default.createElement(
          designSystem.HeadingLevel,
          null,
          React__default.default.createElement(
            "div",
            { className: styles.titleContent },
            pageIcon && React__default.default.createElement("div", { className: styles.pageIcon, style: { fill: pageIconColor }, "data-zds": true }, typeof pageIcon === "string" ? React__default.default.createElement(designSystem.Icon, { color: "inherit", size: "var(--page-icon-size)", name: pageIcon }) : pageIcon),
            React__default.default.createElement(designSystem.Heading, { className: styles.title }, title),
            pageTag && React__default.default.createElement("div", { className: styles.pageTag, "data-zds": true }, typeof pageTag === "string" ? React__default.default.createElement(designSystem.Tag, { variant: "simple", size: "x-small", className: styles.responsiveTag }, pageTag) : pageTag)
          )
        ),
        (actions !== null && actions !== void 0 ? actions : compactActions) && React__default.default.createElement(
          "div",
          { className: styles.actionsContainer, "data-zds": true },
          compactActions && React__default.default.createElement("div", { className: styles.compactActions }, compactActions),
          actions && React__default.default.createElement("div", { className: styles.defaultActions }, actions)
        )
      ),
      description && React__default.default.createElement(designSystem.Text, { tag: "p", type: "Body1Multiline", color: "GrayWarm9", style: { padding: "var(--zds-space-8) 0" } }, description)
    ),
    additionalContent && React__default.default.createElement("div", { className: styles.additionalContent, "data-zds": true }, additionalContent)
  );
};

exports.PageHeader = PageHeader;
//# sourceMappingURL=PageHeader.cjs.js.map
